import { Link } from "react-router-dom";
import { Button } from "@narmi/design_system";

const BackButton = ({
  to,
  label = "Back",
  onClick,
}: {
  to: string;
  label?: string;
  onClick?: () => void;
}) => (
  <Link to={to}>
    <Button testId="sudocontext-back-button" type="button" kind="plain" onClick={onClick}>
      {label}
    </Button>
  </Link>
);

export default BackButton;
